// extracted by mini-css-extract-plugin
export default {"container":"RestoreHistoryButton-module__container__P3pE7Ho","iconButton":"RestoreHistoryButton-module__iconButton__aKpSNlG","button":"RestoreHistoryButton-module__button__WLB966d"};